export default "__VITE_ASSET__gruz_YZH__"